(() => {
  const breakpoint = window.matchMedia('(max-width: 768px)');
  const desc = document.querySelectorAll('.js-image-with-text-new__description');
  const seeMore = document.querySelector('.js-image-with-text-new__see-more');
  const seeLess = document.querySelector('.js-image-with-text-new__see-less');
  if(desc) {
    if(breakpoint.matches) {
      desc.forEach(item => {
        if(item.innerHTML.length >= 900) {
          const itemLength = item.innerHTML.length;
          const defaultContent = item.innerHTML;
          item.innerHTML = `${item.innerHTML.substring(0, 900)}`; 
          seeMore.style.display = 'inline';
          seeMore.addEventListener('click', e => {
            e.preventDefault();
            seeMore.style.display = 'none';
            seeLess.style.display = 'inline';
            item.innerHTML = `${defaultContent.substring(0, itemLength)}`; 
          })
          seeLess.addEventListener('click', e => {
            e.preventDefault();
            seeMore.style.display = 'inline';
            seeLess.style.display = 'none';
            item.innerHTML = `${item.innerHTML.substring(0, 900)}`; 
          })
        } else {
          item.innerHTML = item.innerHTML;
        }
      })
    }
  }
})();